import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { type ProductCardForGallery } from '../CardsGalleryItem';

export function mapProductVariantForGallery(productVariant: OpenApiSchemaProductVariant): ProductCardForGallery {
    const { id, name, price, media_items } = productVariant;

    return { id, name, priceFrom: price ?? '', media: media_items.at(0) };
}
